module.exports = __webpack_public_path__ + "static/media/font_bold.120cae3b.woff";